import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiProduction, ProductionsApi } from '@tytapp/api';
import { PageComponent } from '@tytapp/common';
import { PLAYLIST_TYPES } from '@tytapp/media-playback';
import { UserService } from '@tytapp/user';
import { combineLatest } from 'rxjs';

const VALID_SECTIONS = [...PLAYLIST_TYPES, 'content'] as const;
type Section = (typeof VALID_SECTIONS)[number];

@Component({
    templateUrl: './all-media.component.html'
})
export class AllMediaComponent extends PageComponent {
    private productionsApi = inject(ProductionsApi);

    state = 'loading';
    productions: ApiProduction[];
    page: number;
    total: number;
    pageSize: number;
    mode: Section;
    requestedSection: Section;

    init() {
        combineLatest([this.route.paramMap, this.route.queryParamMap]).subscribe(async ([params, qp]) => {
            this.state = 'loading';

            let page = Number(qp.get('page') ?? 1);
            let productions = await this.productionsApi.all('published', page).toPromise();

            this.mode = <Section>(params.get('section') ?? 'content');
            this.requestedSection = this.mode;

            this.productions = productions;
            this.total = productions.total;
            this.page = page;
            this.pageSize = 30;

            this.state = 'ready';
        })
    }

    goToPage(page) {
        this.router.navigate([], { queryParams: { page } });
    }

    hasItemsOfRequestedType(production: ApiProduction) {
        if (this.requestedSection === 'content')
            return production.full_length_vods?.length > 0 || production.full_length_podcasts?.length > 0 || production.vod_clips?.length > 0;
        else if (this.requestedSection === 'episodes')
            return production.full_length_vods?.length > 0;
        else if (this.requestedSection === 'podcasts')
            return production.full_length_podcasts?.length > 0;
        else if (this.requestedSection === 'clips')
            return production.vod_clips?.length > 0;

        return false;
    }

}